/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

// Define common styles using css helper
const commonStyles = css`
  display: flex;
`;

// Define common crumb styles as a function
const crumbCommonStyles = (cpds) => css`
  color: ${cpds?.breadcrumb__link_crumb__default__text_color};
  font-weight: 400 !important;
  border-bottom: 1px solid transparent;
  padding-top: 0px;
  padding-bottom: 1px;
`;

// Define styled components
const CpdsBreadcrumbNav = styled.nav.attrs(({ className = '' }) => ({
  className: `cpds-meta-roman-book-09 ${className}`,
}))`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const token = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      align-items: center;
      display: flex;
      /* Styles overrides */
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsBreadcrumbOl = styled.ol`
  ${commonStyles}
`;

const CpdsBreadcrumbLi = styled.li`
  ${commonStyles}
  justify-content: flex-start;
  align-items: center;
`;

const CpdsBreadcrumbA = styled.a`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      ${crumbCommonStyles(token)}
      margin-right: 4px;
      text-decoration: none !important;
      transition: all 0.3s;
      cursor: pointer;
      padding-bottom: 3px;
      &:hover {
        border-color: ${token?.breadcrumb__crumb__hover_color};
        padding-top: 0;
      }
      ${commonStyles}
    `;
  }}
`;

const CpdsBreadcrumbSpan = styled.span`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      ${crumbCommonStyles(token)}
      ${commonStyles}
    `;
  }}
`;

const CpdsBreadcrumbSVG = styled.svg`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      width: 8px;
      height: 8px;
      padding: 4px 5px;
      position: relative;
      bottom: 1px;
      & path {
        fill: ${token?.breadcrumb__crumb__arrow_color};
      }
    `;
  }}
`;

export {
  CpdsBreadcrumbNav,
  CpdsBreadcrumbOl,
  CpdsBreadcrumbLi,
  CpdsBreadcrumbA,
  CpdsBreadcrumbSpan,
  CpdsBreadcrumbSVG,
};
